//
//
//
//
//
//
//
//
//
//
//
//

import { ActionText, Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import translations from './TextReadMore.tanslations'

export default {
  components: {
    ActionText,
    Typography,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    characterLimit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isReadMoreActionShown: null,
    }
  },
  computed: {
    translations: () => translations,
    isTextTooLong() {
      return !isEmpty(this.text) && this.text.length > this.characterLimit
    },

    transformedText() {
      if (!this.isTextTooLong || this.isReadMoreActionShown === false) {
        return this.text
      }

      this.toggleReadMoreAction()

      return this.text.substring(0, this.characterLimit).concat('…')
    },
  },
  methods: {
    toggleReadMoreAction() {
      this.isReadMoreActionShown =
        this.isReadMoreActionShown !== null
          ? !this.isReadMoreActionShown
          : this.isTextTooLong
    },
  },
}
